"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var CriteriaInfo = /** @class */ (function (_super) {
    __extends(CriteriaInfo, _super);
    function CriteriaInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CriteriaInfo.prototype.render = function () {
        var criteria = this.props.criteria;
        var insuranceTypeText = 'Standard';
        if (criteria.insuranceType == "0")
            insuranceTypeText = "Standard & Select";
        else if (criteria.insuranceType == "3")
            insuranceTypeText = "Select";
        else if (criteria.insuranceType == "5")
            insuranceTypeText = "Standard";
        else
            insuranceTypeText = "Unknown";
        return (React.createElement("div", { style: { wordWrap: 'normal' } },
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-12" },
                    React.createElement("span", { className: "font-weight-bold" }, " Search Results for: "))),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Age: ")),
                React.createElement("div", { className: "col-sm-8 border" }, criteria.age)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Gender: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (criteria.gender == 'm') ? 'Male' : 'Female')),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Smoker: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (criteria.smoker == 's') ? 'Smoker' : 'Non-Smoker')),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Zip Code: ")),
                React.createElement("div", { className: "col-sm-8 border" }, criteria.zipCode)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Insurance Type: ")),
                React.createElement("div", { className: "col-sm-8 border" }, insuranceTypeText)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Plan Type: ")),
                React.createElement("div", { className: "col-sm-8 border" }, (criteria.groupCode == 'B') ? 'Individual & Group' : criteria.groupCode)),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Effective Date: ")),
                React.createElement("div", { className: "col-sm-8 border" }, new Date(criteria.effectiveDate + ' 00:00').toLocaleDateString('en-US'))),
            React.createElement("div", { className: "row border" },
                React.createElement("div", { className: "col-sm-4 border" },
                    React.createElement("span", { className: "font-weight-bold" }, " Plan(s): ")),
                React.createElement("div", { className: "col-sm-8 border" }, criteria.plans))));
    };
    return CriteriaInfo;
}(React.PureComponent));
;
exports.default = react_redux_1.connect()(CriteriaInfo);
//# sourceMappingURL=CriteriaInfo.js.map